import { takeLatest } from 'redux-saga/effects';
import { getInfo } from './IpAppInfoSagas';
import { APP_INFO_ACTION_TYPES } from '../actionTypes';

export function* getInfoWatcher() {
  yield takeLatest(APP_INFO_ACTION_TYPES.GET.IN_PROGRESS, getInfo);
}
